export default __webpack_public_path__ + "static/media/WORLD_LANGUAGES_FRENCH.ec4eda1e.svg";